import axios from "./axios";

/** POST /api/broker-gateway/order-modification/ — regular order book modification */
export const modifyOrders = async (orderList) => {
  const payload = { order_list: orderList, action: "modify" };
  const response = await axios.post("/api/broker-gateway/order-modification/", payload);
  return response.data;
};

export const cancelOrders = async (orderList) => {
  const payload = { order_list: orderList, action: "cancel" };
  const response = await axios.post("/api/broker-gateway/order-modification/", payload);
  return response.data;
};
